import { Observable } from 'rxjs';
import { memoize } from '@polkadot/util';
import { drr } from './drr.js';
/** @internal */
export function memo(instanceId, inner) {
  const options = {
    getInstanceId: () => instanceId
  };
  const cached = memoize(function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    return new Observable(observer => {
      const subscription = inner(...params).subscribe(observer);
      return () => {
        cached.unmemoize(...params);
        subscription.unsubscribe();
      };
    }).pipe(drr());
  }, options);
  return cached;
}